export enum DataSetEventTypeEnums {
    /**
     * Unknown,just for fallback
     */
    UNKNOWN = 999,
    /**
     * Create/Add a new dataSet to the db
     */
    CREATE = 0,
    /**
     * Delet an dataSet from the db
     */
    DELETE = 1,
    /**
     * Update/Edit an existing dataSet from the db
     */
    UPDATE = 2,
    /**
     * Create new dataset with unit from mymill data.
     * Complete dataset will be created in BE.
     */
    CREATE_MYMILL = 3,
}
